import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import TaxonomyExpertisesPage from './Page';
import type { TaxonomyExpertise } from '../../../types/uncinc_profile/taxonomy';

type ExpertisesViewmode = 'teaser' | 'page';

interface ExpertisesProps {
  entity: ImmutableEntity<TaxonomyExpertise>;
  viewMode: ExpertisesViewmode;
}

const TaxonomyExpertisesWrapper: React.FC<ExpertisesProps> = ({ entity, viewMode, ...props }) => {
  switch (viewMode) {
    case 'page':
    default:
      return <TaxonomyExpertisesPage entity={entity} {...props} />;
  }
};

export default TaxonomyExpertisesWrapper;
